export const SUPPORT_CONTACTS = {
  telefones: [
    { 
      number: '(67) 3318-4778', 
      rawNumber: '6733184778', 
      description: 'Suporte Técnico' 
    },
    { 
      number: '(67) 3318-4782', 
      rawNumber: '6733184782', 
      description: 'Suporte Técnico' 
    }
  ],
  whatsapp: [
    {
      number: '(67) 3318-4778',
      rawNumber: '6733184778',
      description: 'Suporte WhatsApp',
    },
    {
      number: '(67) 3318-4782',
      rawNumber: '6733184782',
      description: 'Suporte WhatsApp'
    }
  ],
  horarioAtendimento: {
    dias: 'Segunda a Sexta',
    horario: '8h às 18h',
    timezone: 'Horário de MS'
  }
};